module.exports = __webpack_public_path__ + "static/img/news_19.2102743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_19.jpg
// module id = uqrB
// module chunks = 2